export const levels = [
    {
        'short': 'FR',
        'long': 'Freshman'
    },
    {
        'short': 'SO',
        'long': 'Sophomore'
    },
    {
        'short': 'JR',
        'long': 'Junior'
    },
    {
        'short': 'SR',
        'long': 'Senior'
    },
    {
        'short': 'GR',
        'long': 'Graduate'
    }
]